The textual representation of this selling point for displaying to the user.
